import axios from "axios"
import { authHeader, baseUrl } from "../../utils"
import { DASHBOARD_ERROR, GETTING_DASHBOARD_DATA, GET_DASHBOARD_DATA } from "../types"

export const fetchDashboardData = () => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: GETTING_DASHBOARD_DATA,
            payload: true
        })

        // Fetch general dashboard data
        const response = await axios.get(`${baseUrl}/dashboards/general`, { headers })
        
        // Fetch invoice stats (pending count and amount)
        const invoicesResponse = await axios.get(`${baseUrl}/invoices?status=pending&perPage=1`, { headers })
        
        const dashboardData = {
            ...response.data.data,
            invoices: {
                pending: invoicesResponse.data.data?.total || 0,
                pendingAmount: invoicesResponse.data.data?.totalAmount || 0
            }
        }
        
        dispatch({
            type: GET_DASHBOARD_DATA,
            payload: dashboardData
        })
        
    }
    catch(error){
        dispatch({
            type: DASHBOARD_ERROR,
            error
        })
    }
}
